import { findComponentUpward, findComponentsUpward } from '../../../../utils/assist'
export default {
    data () {
        return {
            menu: findComponentUpward(this, 'YYMenu')
        }
    },
    computed: {
        hasParentSubmenu () {
            return !!findComponentUpward(this, 'YYSubmenu')
        },
        parentSubmenuNum () {
            return findComponentsUpward(this, 'YYSubmenu').length
        }
    }
}
